import React from 'react';

import moment from 'moment';

const ViewItemGrid = ({ grnData, currencyPrecision }) => {
    const netAmount = grnData?.reduce((sum, row) => sum + (parseFloat(row?.amount) || 0), 0)
    const totalVat = grnData?.reduce((sum, row) => sum + (parseFloat(row?.vatAmount) || 0), 0)
    const totalDiscountAmount = grnData?.reduce((sum, row) => sum + (parseFloat(row?.discountAmount) || 0), 0)
    const totalDiscount = grnData?.reduce((sum, row) => sum + (parseFloat(row?.discount) || 0), 0)
    const calculatedTotal = grnData?.reduce((sum, row) => sum + (parseFloat(row?.amount - row?.vatAmount) || 0), 0)
    return (
        <div>
            <div className='table-container p-1 mb-5' style={{ overflowX: 'auto', height: "auto" }}>
                <table>
                    <thead className='dynoTable'>
                        <tr>
                            <th>Sr no</th>
                            <th>Item No</th>
                            <th>Description</th>
                            <th>Item Specs</th>
                            <th>Qty</th>
                            <th>Packing UOM</th>
                            <th>Inventory Qty</th>
                            <th>Free Qty</th>
                            <th>Unit Price</th>
                            <th>VAT Desc</th>
                            <th>VAT %</th>
                            <th>VAT Amount</th>
                            <th>Amount</th>
                            <th>Batch No</th>
                            <th>Exp Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {grnData?.map((row, index) => (
                            <tr key={index}>
                                <td className='m-0 p-0'><input className='p-2' value={index + 1} disabled style={{ width: "70px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.itemCode} style={{ width: "100px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.itemDescription} style={{ width: "130px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.specification} style={{ width: "120px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled style={{ width: "70px" }} value={row.qty} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.uom} style={{ width: "130px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.convToInvUOM * row.qty || 0} style={{ width: "130px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.extraQty} style={{ width: "100px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={Number(row.unitPrice).toFixed(currencyPrecision) || 0} style={{ width: "120px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' value={row.vatDesc} disabled style={{ width: "100px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' value={row.vatPerc + "%"} disabled style={{ width: "80px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' value={Number(row.vatAmount).toFixed(currencyPrecision) || 0} disabled style={{ width: "120px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={Number(row.amount).toFixed(currencyPrecision) || 0} style={{ width: "100px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' value={row.batchNo} disabled style={{ width: "100px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' value={row?.expDate ? moment(row?.expDate).format('DD-MMM-YYYY') : "---"}
                                    disabled style={{ width: "130px" }} /></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className='mt-3 p-1'>
                <div className='d-flex justify-content-around boxs p-2 mt-5'>
                    <div className='d-flex gap-2'>
                        <div className="totalhead center">Total Amount</div>
                        <div className='field'>{calculatedTotal?.toFixed(currencyPrecision || 0) || "---"}</div>
                    </div>
                    <div className='d-flex gap-2'>
                        <div className="totalhead center">Total Vat</div>
                        <div className='field'>{totalVat?.toFixed(currencyPrecision || 0) || "---"}</div>
                    </div>
                    <div className='d-flex gap-2'>
                        <div className="totalhead center">Net Amount</div>
                        <div className='field'>{netAmount?.toFixed(currencyPrecision || 0) || "---"}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewItemGrid;